import { Component, Input, OnChanges, SimpleChanges, inject } from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { CollapseComponent, EmptyStateComponent } from '@tecalisdev/infinity';
import { OperationOcrDetailsDataComponent } from '../../../../../shared/components/operations/ocr/operation-ocr-details-data/operation-ocr-details-data.component';
import { OperationDetailOperationMetaComponent } from '../../../../../shared/components/operations/common/operation-detail-operation-meta/operation-detail-operation-meta.component';
import { IOperationDetailResponse } from '../../../../models/operations.models';
import { IOperationOcrDetail } from '../../../../../processes/models/processes.models';
import { collectOcrAdminImageUrls } from '../../../../../processes/utils/ocr-admin-images.util';
import { OperationDetailTabsDetailsMediaComponent } from '../operation-detail-tabs-details-media/operation-detail-tabs-details-media.component';
import { NOT_AVAILABLE_DISPLAY } from '../../../../../core/utils/utils';
import { ocrDetailCaptureMethodLabelKey } from '../../../../../workflows/utils/workflow-ocr.util';

type OcrDetailsCollapseSection = 'data' | 'media' | 'operation';

@Component({
	selector: 'app-operation-detail-tabs-details-ocr',
	imports: [
		TranslatePipe,
		CollapseComponent,
		EmptyStateComponent,
		OperationDetailTabsDetailsMediaComponent,
		OperationOcrDetailsDataComponent,
		OperationDetailOperationMetaComponent,
	],
	templateUrl: './operation-detail-tabs-details-ocr.component.html',
	styleUrl: './operation-detail-tabs-details-ocr.component.scss',
})
export class OperationDetailTabsDetailsOcrComponent implements OnChanges {
	@Input() detail: IOperationDetailResponse;

	private trans = inject(TranslateService);

	public ocrData: IOperationOcrDetail | null = null;

	/** Hay al menos una captura OCR (anverso, reverso o temporal). */
	public hasOcrMedia = false;

	/** Mismo criterio acordeón que POL en detalle de operación (una sección expandida). */
	public expandedCollapseSection: OcrDetailsCollapseSection | null = 'data';

	public toggleCollapse(section: OcrDetailsCollapseSection, expanded?: boolean): void {
		this.expandedCollapseSection = !expanded ? null : section;
	}

	public ngOnChanges(changes: SimpleChanges): void {
		if (!changes['detail']) return;
		this.ocrData = this.detail?.data ? (this.detail.data as unknown as IOperationOcrDetail) : null;
		this.hasOcrMedia = this.computeHasOcrMedia(this.ocrData);
	}

	public ocrTriesLabel(): string {
		if (this.ocrData?.total_tries == null) return NOT_AVAILABLE_DISPLAY;
		return this.ocrData.total_tries.toString();
	}

	/** Método real del intento (`capture_method`); fallback al `mode` del workflow (NIF-921). */
	public ocrCaptureMethodLabel(): string {
		const key = ocrDetailCaptureMethodLabelKey(this.ocrData?.capture_method, this.ocrData?.mode);
		return key ? this.trans.instant(key) : NOT_AVAILABLE_DISPLAY;
	}

	public get showMiDni(): boolean {
		return this.ocrData?.capture_method === 'MIDNI';
	}

	private computeHasOcrMedia(ocr: IOperationOcrDetail | null): boolean {
		const imgs = ocr?.images;
		if (!imgs) {
			return false;
		}
		return collectOcrAdminImageUrls(imgs).length > 0;
	}
}
